<div class="p-20 fx-row fx-wrap align-items-center justify-content-center text-center">
    <div class="fx-flex-100 align-items-center justify-content-center text-center">
        <span class="title mb-10 text-center">{{'DOCUMENT.ADD_TAG' | translate}}</span>
    </div>
    <span class="text mt-20">{{'DOCUMENT.ADD_TAG_HINT' | translate}}</span>
    <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mt-20">
        <app-tag-select label="{{'ENTITIES.TAGS' | translate}}" [multiple]="true" [search]="true" class="mt-10 fx-flex"
            [(value)]="tags" [emitOnInit]="false" [disabledValues]="existingTags">
        </app-tag-select>
    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button class="main-button fx-flex ml-10" (click)="onAdd()">{{'ACTIONS.ADD' | translate}}</button>
    </div>
</div>